import { Search, CreditCard, Zap } from "lucide-react";
import { COPY } from "@/content/copy";

const steps = COPY.howItWorks.steps.map((step, index) => ({
  icon: [Search, CreditCard, Zap][index],
  title: step.title,
  description: step.description,
}));

const HowItWorksSection = () => {
  return (
    <section className="py-20 px-4 bg-background" id="how-it-works" data-section="how-it-works">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-heading font-semibold mb-4 text-primary">
            {COPY.howItWorks.title}
          </h2>
          <div className="inline-flex items-center gap-2 bg-primary/5 rounded-full px-6 py-3 mt-4">
            <span className="text-lg font-semibold font-mono text-primary">BNPL up to AED 20,000</span>
            <span className="text-sm text-muted-foreground">• Flexible payment terms • Quick approval</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center group">
              <div className="relative mb-6">
                <div className="w-20 h-20 mx-auto bg-primary rounded-full flex items-center justify-center glow-effect group-hover:scale-110 smooth-transition">
                  <step.icon className="w-10 h-10 text-white" />
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-10 left-[calc(50%+2.5rem)] w-[calc(100%-5rem)] h-0.5 bg-primary/20">
                    <div className="absolute right-0 top-1/2 -translate-y-1/2 w-2 h-2 border-t-2 border-r-2 border-primary/30 rotate-45 -translate-x-1" />
                  </div>
                )}
              </div>
              <h3 className="text-2xl font-heading font-semibold mb-4 text-primary">
                {step.title}
              </h3>
              <p className="text-muted-foreground font-body leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        {/* Financing Amount Diagram */}
        <div className="mt-16 max-w-4xl mx-auto">
          <div className="bg-card rounded-2xl p-8 card-shadow">
            <h3 className="text-xl font-heading font-semibold text-center mb-8">How much can I finance?</h3>
            <div className="flex flex-col md:flex-row items-center justify-center gap-6">
              <div className="flex flex-col items-center text-center">
                <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mb-2">
                  <span className="text-sm font-bold font-mono text-primary">Up to AED 20,000</span>
                </div>
                <span className="text-xs font-medium">Instant BNPL</span>
              </div>
              <div className="hidden md:block w-12 h-0.5 bg-primary/20" />
              <div className="flex flex-col items-center text-center">
                <div className="w-20 h-20 bg-success/10 rounded-full flex items-center justify-center mb-2">
                  <span className="text-sm font-bold font-mono text-success">AED 20,000-100,000</span>
                </div>
                <span className="text-xs font-medium">Bank instalment plan</span>
              </div>
            </div>
            <p className="text-xs text-muted-foreground text-center mt-4">
              BNPL up to AED 20,000 per UAE Central Bank regulations. Bank instalments available above AED 20,000, activated directly with your bank.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
